// extracted by mini-css-extract-plugin
export default {"btn":"SoSVyGj8ETC4SuyIgIZKRg==","tooltip":"xXvlM95A3vxcpJU40AQDXg=="};